<template>
  <div class="incomeReleaseRecord">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="form.agent" placeholder="请选择代理">
            <el-option
              v-for="item in form.agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.auditStatus" placeholder="请选择发放状态">
            <el-option
              v-for="item in form.auditStatusData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.type" placeholder="请选择奖励类型">
            <el-option
              v-for="item in form.typeData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button type="primary" size="small">审批发放奖励</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
        <el-table-column :label="$t('common.handle')" width="240">
          <template slot-scope="scope">
            <el-button size="mini" type="primary">{{$t('common.edit')}}</el-button>
            <el-button size="mini" type="primary">{{$t('common.cancle')}}</el-button>
            <el-button size="mini" type="danger">审批</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentIncomeReleaseList"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'

  export default {
    name: 'incomeReleaseRecord',
    data() {
      return {
        form: {
          agent: '',
          agentData: [],
          startTime: new Date(),
          endTime: new Date(),
          auditStatus: '',
          auditStatusData: [],
          type: '',
          typeData: []
        },
        tableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '代理层级', id: 'twoLevelRatio' },
          { name: '开始时间', id: 'startTime' },
          { name: '结束时间', id: 'endTime' },
          { name: '奖励类型', id: 'assignTypes' },
          { name: '奖励统计金额', id: 'assignAmount' },
          { name: '实际发放奖励金额', id: 'actualAssignAmount' },
          { name: '奖励发放状态', id: 'auditStatuss' },
          { name: '审批人', id: 'auditor' },
          { name: '审批时间', id: 'auditTime' },
          { name: '备注', id: 'remark' }
        ],
        tableData: [],
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10 //当前页条数数
      }
    },
    methods: {
      getIncomeReleaseData(data) {
        nationalMarketing.queryAgentIncomeListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].startTime)) {
                  data[i].startTime = new Date(data[i].startTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].endTime)) {
                  data[i].endTime = new Date(data[i].endTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].auditTime)) {
                  data[i].auditTime = new Date(data[i].auditTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].assignType)) {
                  if (data[i].assignType == 0) data[i].assignTypes = '直接'
                  if (data[i].assignType == 1) data[i].assignTypes = '间接'
                }
                if (Util.isNotEmpty(data[i].auditStatus)) {
                  if (data[i].auditStatus == 0) data[i].auditStatuss = '待审批'
                  if (data[i].auditStatus == 1) data[i].auditStatuss = '审批通过'
                  if (data[i].auditStatus == 2) data[i].auditStatuss = '审批不通过'
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initIncomeReleaseData() {
        let data = {
          pageNum: this.currentPage
        }
        this.getIncomeReleaseData(data)
      },
      changeCurrentIncomeReleaseList(val) {
        this.currentPage = val
        let data = {
          pageNum: val
        }
        this.getIncomeReleaseData(data)
      }
    },
    mounted() {
      this.initIncomeReleaseData()
    }
  }
</script>

<style lang="scss" scoped>
  .incomeReleaseRecord {
    margin: 20px;

    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
</style>
